module.exports = __webpack_public_path__ + "static/media/Desktop-Banner-Doc-Upload.fb247d37.jpg";